/**
 * STAN SPRZED ZMIANY — jak go pokazać w rejestrze zmian (15.10.2026).
 *
 * ⚠️ POKAZUJEMY TYLKO TO, CO ZMIANA RUSZA: przy łatce stare wartości jej kolumn (nowe stoją obok,
 * w „Dane"), przy usunięciu cały usunięty wiersz, przy wstawieniu — że wiersza nie było. Pełny
 * wiersz przy każdej łatce zalałby tabelę kolumnami, których nikt nie zmieniał.
 */
export type StanPrzedNaEkranie = { wezel: string; maszyna?: string | null; istnial: boolean; wiersz: Record<string, unknown> | null };

export type OpisPrzed =
  | { rodzaj: 'brak' }
  | { rodzaj: 'rozny'; wezly: string[] }
  | { rodzaj: 'nieBylo' }
  | { rodzaj: 'wiersz'; wartosci: Record<string, unknown> };

const ci = (s: string) => s.toLowerCase();

function odcisk(s: StanPrzedNaEkranie): string {
  if (!s.istnial || s.wiersz === null) return 'brak';
  return JSON.stringify(
    Object.keys(s.wiersz)
      .sort((a, b) => ci(a).localeCompare(ci(b)))
      .map((k) => [ci(k), s.wiersz![k] ?? null]),
  );
}

export function opisPrzed(akcja: string, payload: Record<string, unknown> | null, przed: readonly StanPrzedNaEkranie[]): OpisPrzed {
  if (przed.length === 0) return { rodzaj: 'brak' };
  if (new Set(przed.map(odcisk)).size > 1) return { rodzaj: 'rozny', wezly: przed.map((p) => p.maszyna ?? p.wezel) };
  const p = przed[0]!;
  if (!p.istnial || p.wiersz === null) return { rodzaj: 'nieBylo' };
  if (akcja === 'P' && payload !== null) {
    const wartosci: Record<string, unknown> = {};
    for (const kol of Object.keys(payload)) {
      const k = Object.keys(p.wiersz).find((x) => ci(x) === ci(kol));
      wartosci[kol] = k === undefined ? null : p.wiersz[k];
    }
    return { rodzaj: 'wiersz', wartosci };
  }
  return { rodzaj: 'wiersz', wartosci: p.wiersz };
}
